// extracted by mini-css-extract-plugin
module.exports = {"bookSlotModal":"BookSlotModal_bookSlotModal__1z8O6"};